function isTrustedVideoEmbedSrc(src) {
  const s = String(src || '').trim();
  return (
    /^https:\/\/(www\.)?(youtube\.com|youtube-nocookie\.com)\/embed\/[\w-]+/i.test(s)
    || /^https:\/\/player\.vimeo\.com\/video\/\d+/i.test(s)
  );
}

/**
 * Санітизація HTML курсу/матеріалу перед dangerouslySetInnerHTML.
 * Лишає <video> і довірені YouTube/Vimeo iframe.
 */
export function sanitizeCourseHtml(html) {
  if (!html) return '';
  if (!String(html).includes('<')) {
    return String(html)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\n/g, '<br/>');
  }
  try {
    const doc = new DOMParser().parseFromString(`<div id="root">${html}</div>`, 'text/html');
    const root = doc.getElementById('root');
    if (!root) return '';
    root.querySelectorAll(
      'script, style, object, embed, form, link, meta, base, svg, math, frame, frameset, input, button, textarea, select',
    ).forEach((el) => el.remove());
    root.querySelectorAll('iframe').forEach((el) => {
      if (!isTrustedVideoEmbedSrc(el.getAttribute('src'))) el.remove();
    });
    root.querySelectorAll('*').forEach((el) => {
      [...el.attributes].forEach((a) => {
        const n = a.name.toLowerCase();
        const v = a.value || '';
        if (n.startsWith('on') || n === 'srcdoc' || n === 'formaction' || n === 'xlink:href') {
          el.removeAttribute(a.name);
        } else if ((n === 'href' || n === 'src') && /^\s*(javascript:|vbscript:|data:text\/html)/i.test(v)) {
          el.removeAttribute(a.name);
        } else if (n === 'src' && /^\s*data:/i.test(v) && !/^\s*data:image\//i.test(v)) {
          el.removeAttribute(a.name);
        } else if (n === 'style' && /expression|javascript:/i.test(v)) {
          el.removeAttribute(a.name);
        }
      });
    });
    return root.innerHTML;
  } catch {
    return '';
  }
}
